import script from "./AsideMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./AsideMenu.vue?vue&type=script&setup=true&lang=js"

import "./AsideMenu.vue?vue&type=style&index=0&id=219c4cb8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-219c4cb8"]])

export default __exports__